import { ws } from '@/helpers/ws';
import { useAppSelector } from '@/hooks/redux';
import { tokensSelector } from '@/store/auth/authSlice';
import { useEffect } from 'react';
// import { WS_TOKEN_EXPIRED } from '@/shared/features/websockets/events';
// import { useAuthRefreshMutation } from '@/api/auth';
// import { mutex } from '@/store/emptyApi';
// import { MutexInterface } from 'async-mutex';

export const useWS = () => {
  const { accessToken, refreshToken } = useAppSelector(tokensSelector);

  // const [updateToken] = useAuthRefreshMutation();

  useEffect(() => {
    // case when access token is being refreshed or not logged in;
    if (!accessToken || accessToken === refreshToken) {
      // close all connections
      ws.removeToken();
      return;
    }

    ws.addToken(accessToken);
  }, [accessToken, refreshToken]);

  // useEffect(() => {
  //   const handleTokenExpired = async () => {
  //     if (mutex.isLocked()) await mutex.waitForUnlock();
  //
  //     let release: MutexInterface.Releaser | null = null;
  //
  //     try {
  //       await updateToken().unwrap();
  //       release = await mutex.acquire();
  //     } catch (err) {}
  //     release?.();
  //   };
  //
  //   document.addEventListener(WS_TOKEN_EXPIRED as any, handleTokenExpired);
  //
  //   return () => {
  //     document.removeEventListener(WS_TOKEN_EXPIRED as any, handleTokenExpired);
  //   };
  // }, [updateToken]);
};
